import { apiFetch } from "./api";

/**
 * Create a PotentialCustomerLead in the backend.
 *
 * Intended for lightweight "email capture" flows (e.g., landing page CTAs).
 * The backend accepts a partial payload; callers should validate as needed.
 */
export const submitPotentialCustomerLead = async (payload = {}, fetchOptions = {}) => {
  const mergedHeaders = {
    "Content-Type": "application/json",
    ...(fetchOptions.headers || {}),
  };

  return apiFetch("/api/leads/submit/", {
    method: "POST",
    ...fetchOptions,
    headers: mergedHeaders,
    body: JSON.stringify(payload || {}),
  });
};

